import React from "react";

const RoleListTr = () => {
	return (
		<>
			<tr>
				<td>
					<div className="d-flex px-2 py-1">
						<div className="d-flex flex-column justify-content-center">
							<p className="text-xs text-secondary mb-0">1</p>
						</div>
					</div>
				</td>
				<td>
					<p className="text-xs font-weight-bold mb-0">Pranay Masulkar</p>
				</td>
				<td className="align-middle text-center">
					<span className="badge badge-sm bg-gradient-success">Active</span>
				</td>
			</tr>
		</>
	);
};

export default RoleListTr;
